import { api, entity } from "src/infra/api/rpc/api";
import { Pager } from "../../domain/model/common";
import { SearchHighlight } from "../../domain/model/search_highlight";
import { TCreateScoutRequest } from "../../domain/repository/scout_repository";

// client scout customer list
interface ISearchCustomerListByClientRequest {
  pager?: Pager;
  query: string;
  singleSkillTagIDs: string[];
  occupationSkillTagCategory: entity.OccupationSkillTag.Category;
  occupationSkillTagId: string;
}
class SearchCustomerListByClientRequest
  implements ISearchCustomerListByClientRequest
{
  public pager: Pager;
  public query: string;
  public singleSkillTagIDs: string[];
  public multiSkillTagIDs: string[];
  public occupationSkillTagCategory: entity.OccupationSkillTag.Category;
  public occupationSkillTagId: string;
  public gender: entity.User.Gender;
  public age: api.CustomerAgeSearchType;
  public workIntention: entity.Customer.WorkIntention;
  public fullTimePossibility: entity.Customer.FullTimePossibility;
}

// client scout detail
interface IGetCustomerByClientRequest {
  customerId: string;
}
class GetCustomerByClientRequest implements IGetCustomerByClientRequest {
  public customerId: string;
}

interface ICreateScoutCustomerByClientRequest {
  req: TCreateScoutRequest;
}
class CreateScoutCustomerByClientRequest
  implements ICreateScoutCustomerByClientRequest
{
  public req: TCreateScoutRequest;
}

interface ICreateClientBookmarkByClientRequest {
  customerId?: string;
}
class CreateClientBookmarkByClientRequest
  implements ICreateClientBookmarkByClientRequest
{
  public customerId: string;
}

interface IDeleteClientBookmarkByClientRequest {
  customerId?: string;
}
class DeleteClientBookmarkByClientRequest
  implements IDeleteClientBookmarkByClientRequest
{
  public customerId: string;
}

interface ICopyHighlightsByClientRequest {
  highlights?: SearchHighlight[];
}
class CopyHighlightsByClientRequest implements ICopyHighlightsByClientRequest {
  public highlights: SearchHighlight[];
}

interface IDeleteHighlightsByClientRequest {}
class DeleteHighlightsByClientRequest
  implements IDeleteHighlightsByClientRequest {}

export {
  CopyHighlightsByClientRequest,
  CreateClientBookmarkByClientRequest,
  CreateScoutCustomerByClientRequest,
  DeleteClientBookmarkByClientRequest,
  DeleteHighlightsByClientRequest,
  // client scout customer detail
  GetCustomerByClientRequest,
  SearchCustomerListByClientRequest,
};



// WEBPACK FOOTER //
// ./src/presentation/request/scout_request.ts